export const FAC_PAYMENT_PROCESSING_FEE = 0.03